/**
 * @ngdoc object
 * @name bo.objects.controller:BoObjectEditController
 *
 * @description
 *
 */
import {AbstractEditorController} from './abstract-editor-controller';

class BoObjectEditController extends AbstractEditorController {

    constructor($http, $state, $stateParams, Alert, growl, NavHelper) {
        super($http, $state, $stateParams, Alert, growl, NavHelper);
        this.model = null;
        this.typeSelectionDisabled = true;

        this.headline = 'Edit Bookable-object';

        this._loadObject().then(() => {
            this._updateNavigation();
            this._loadAvailableTypes()
        });
    }

    save() {
        this.api.put(`bo/objects/${this.model.id}`, this._prepareModelForApi()).then(() => {
            this.growl.success('Object was saved successful', {title: 'Success'});
            this.cancel();
        }, () => {
            this.growl.error('Please try again', {title: 'Save error'});
        });
    }

    cancel() {
        this.state.go('app.bo.objects.details', {
            objectId: this.model.id
        })
    }
}

angular
    .module('festzelt-os.modules.bo.objects')
    .controller('BoObjectEditController', BoObjectEditController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/controllers/edit-controller.js